<template>
  <div class="absolute bottom-5 w-full right-0">
    <NBox
      class="flex items-center justify-between mx-2 text-neutral-secondary-press py-2 px-4"
    >
      <span>
        <NText variant="caption1" class="ml-6">
          {{ t('misc.value') }} {{ t('modules.portfolio.title') }}
        </NText>

        <Number #="{ number }" :value="portfolioSummary.sumValues" round>
          <NText variant="caption1" weight="medium">
            {{ number }}
          </NText>
        </Number>
      </span>

      <span class="inline-flex items-center">
        <NText variant="caption1" class="ml-6">
          {{ t('misc.return') }}
        </NText>

        <Number
          #="{ number }"
          :value="portfolioSummary.sumReturnValuesPercentage / 100"
          number-style="percent"
          maximum-fraction-digits="2"
          minimum-fraction-digits="2"
          sign-display="always"
        >
          <NText
            dir="ltr"
            class="ml-1"
            weight="medium"
            variant="caption1"
            :class="
              portfolioSummary.sumReturnValuesPercentage > 0
                ? 'text-brand-primary'
                : 'text-critical-primary'
            "
          >
            ({{ number }})
          </NText>
        </Number>

        <Number
          #="{ number }"
          :value="portfolioSummary.sumReturnValues"
          round
          sign-display="always"
        >
          <NText class="ml-1" variant="caption1" weight="medium" dir="ltr">
            {{ number }}
          </NText>
        </Number>

        <NText variant="overline" class="text-neutral-secondary">
          {{ t('misc.rial') }}
        </NText>
      </span>

      <span>
        <NText variant="caption1" class="ml-6">
          {{ t('modules.portfolio.portfolioQuantity') }}
        </NText>

        <Number #="{ number }" :value="portfolioSummary.quantity">
          <NText class="ml-1" variant="caption1" weight="medium">
            {{ number }}
          </NText>
        </Number>
      </span>

      <span>
        <NText variant="caption1" class="ml-6">
          {{ t('modules.portfolio.totalBuyAmount') }}
        </NText>

        <Number
          #="{ number }"
          :value="portfolioSummary.sumBuyTotalTradeVolumes"
          round
        >
          <NText class="ml-1" variant="caption1" weight="medium">
            {{ number }}
          </NText>
        </Number>
      </span>
    </NBox>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import Number from '@/components/Number.vue';

type PortfolioSummaryProps = {
  portfolioSummary: {
    quantity: number;
    sumValues: number;
    sumReturnValues: number;
    sumReturnValuesPercentage: number;
    sumBuyTotalTradeVolumes: number;
  };
};

defineProps<PortfolioSummaryProps>();

const { t } = useI18n();
</script>
